<template>
  <div class="w-full col-span-full">
    <div
      class="relative flex items-center"
      v-click-outside="hideSuggestionsList"
    >
      <input
        :name="name"
        autocomplete="off"
        class="bg-white rounded-md placeholder-gray-600 block w-full focus:outline-none focus:shadow-outline-indigo appearance-none transition duration-150 ease-in-out sm:leading-5 truncate"
        v-model="mutableValue"
        :placeholder="placeholder"
        :class="{
          'text-lg py-5 pl-5 pr-7': big != null && big,
          'text-sm pl-3 pr-8 py-2 xxl:pl-4 xxl:pr-11 xxl:py-3 2xl:pl-5 2xl:pr-13 2xl:py-4':
            big == null || !big,
          'border-red-500': error && errorMsg != '',
          'border-indigo-600': !(error && errorMsg != ''),
          shadow: !hasBorder,
          'border border-opacity-50 focus:border-indigo-300': hasBorder,
        }"
        @click="displaySuggestionsList"
      />
      <div
        class="absolute"
        :class="{
          'right-4': big == null || !big,
          'right-5': big != null && big,
        }"
      >
        <icon v-if="!isSearching" :name="icon" :class="iconColor" />
        <div
          v-if="isSearching"
          class="flex justify-center border rounded-full h-3 w-3 mr-1 sm:h-4 sm:w-4 sm:mr-1.5 border-t-2 border-r-2 border-l-0 border-b-0 border-gray-900 border-opacity-25 animate-spin"
        />
      </div>
      <div
        v-if="hasSuggestion"
        :class="
          'absolute bg-white shadow rounded-md ' +
          suggestionsListMaxHeight +
          ' w-full overflow-scroll mt-15 z-30 self-start'
        "
      >
        <slot name="suggestionsList" />
      </div>
    </div>
    <div v-if="error" class="text-red-500 text-sm">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';

import ClickOutside from 'vue-click-outside';

export default {
  props: {
    name: String,
    libelle: String,
    value: [String, Number],
    placeholder: String,
    error: Boolean,
    msgError: {
      type: String,
      required: false,
      default: '',
    },
    big: Boolean,
    inherits: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      required: false,
      default: true,
    },
    icon: {
      type: String,
      required: false,
      default: 'search',
    },
    iconColor: {
      type: String,
      required: false,
      default: 'text-indigo-600',
    },
    isSearching: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasSuggestion: {
      type: Boolean,
      required: false,
      default: false,
    },
    suggestionsListMaxHeight: {
      type: String,
      required: false,
      default: 'max-h-72',
    },
  },

  components: {
    Icon,
  },

  data: function () {
    return {
      mutableValue: this.value,
      errorMsg: this.msgError,
      textLibelle: '&nbsp;',
    };
  },

  mounted() {
    //assign text to textLibelle if prop Libelle is filled
    if (this.libelle != undefined && this.libelle != null) {
      this.textLibelle = this.libelle;
    }

    if (this.msgError) {
      this.errorMsg = this.msgError;
    }
  },

  methods: {
    displaySuggestionsList() {
      this.$emit('displaySuggestionsList', true);
    },

    hideSuggestionsList() {
      this.$emit('displaySuggestionsList', false);
    },
  },

  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);

      if (this.msgError) {
        this.errorMsg = this.msgError;
      } else {
        this.errorMsg = '';
      }
    },

    value() {
      this.mutableValue = this.value;
    },

    msgError() {
      this.errorMsg = this.msgError;
    },
  },

  beforeDetroy() {
    this.typeField = this.type;
  },

  directives: {
    ClickOutside,
  },
};
</script>
